




















import { index, publish } from '@/api/drafts'
import { Component, Vue } from 'vue-property-decorator'

@Component({
  components: {}
})

export default class extends Vue {
  config: Record<string, any> = {
    api: index,
    paginate: false,
    fields: [
      { prop: 'template_id', label: '#' },
      { prop: 'user_version', label: 'Version' },
      { prop: 'user_desc', label: 'Description', width: 300 }
    ]
  }

  onPublish (row: any) {
    this.$ask(async () => {
      await publish(row)
      const el: any = this.$refs.table
      el.getItems(1)
      this.$message.success('The version has been published')
    })
  }
}
